import { QUARTERLY_ALL_ACTIONS_TYPE } from "../actions-type";

const initialState = {
  quarterlyData: [],
  loading: false,
  createLoading: false,
};

export const quarterlyTargetPlanReducer = (state = initialState, action) => {
  switch (action.type) {
    case QUARTERLY_ALL_ACTIONS_TYPE.QUARTERLY_TARGET_PLAN_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case QUARTERLY_ALL_ACTIONS_TYPE.QUARTERLY_TARGET_PLAN_CREATE_LOADING:
      return {
        ...state,
        createLoading: action.payload,
      };
    case QUARTERLY_ALL_ACTIONS_TYPE.GET_QARTERLY_TARGET_PLAN:
      return {
        ...state,
        quarterlyData: action.payload,
      };
    case QUARTERLY_ALL_ACTIONS_TYPE.RESTE_QUARTERLY_TARGET_PLAN:
      return {
        ...state,
        quarterlyData: [],
        loading: false,
        createLoading: false,
      };
    default:
      return state;
  }
};
